import { render } from "./MatchView.vue?vue&type=template&id=2d7beea4"
import script from "./MatchView.vue?vue&type=script&lang=js"
export * from "./MatchView.vue?vue&type=script&lang=js"

import "./MatchView.vue?vue&type=style&index=0&id=2d7beea4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__